exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-80568fe6]{padding:20px}.single-large[data-v-80568fe6]{display:block;margin:30px auto;padding:.5rem 1.5rem}", ""]);

// exports
